import ImportProgress from "./ImportProgress";
import ExportProgress from "./ExportProgress";

const importExportComponents = {
  ImportProgress,
  ExportProgress
}

export default importExportComponents